import {
  UserGroupIcon,
  PlusCircleIcon,
  EnvelopeIcon,
  BellIcon,
  CalendarIcon,
} from "@heroicons/react/24/solid";
import { GuestList, AdminSettings } from "./pages/users/admin"; // Solo las rutas necesarias para usuarios
import { ProspectsList } from "./pages/users/admin/Prospects/List";
import Notifications from "./pages/users/admin/notifications/notifications";
import Calendario from "./pages/users/admin/calendario/Calendario";
import { Calendar, User2 } from "lucide-react";
import Account from "./pages/users/cliente/cuenta/account";
import Podcast from "./pages/users/cliente/podcast/podcast";

const icon = {
  className: "w-5 h-5 text-inherit",
};

export const routes = [
  {
    userType: "Admin", // Solo usuarios de tipo "Admin"
    layout: "admin",
    pages: [
      {
        icon: <EnvelopeIcon {...icon} />,
        name: "Prospectos", // Solo ruta para "Invitados"
        path: "/prospects",
        element: <ProspectsList />, // Componente que muestra la lista de invitados
        isList: true,
        subpages: [],
        hidden: false,
      },
      {
        icon: <UserGroupIcon {...icon} />,
        name: "Clientes", // Solo ruta para "Invitados"
        path: "/clientes",
        element: <GuestList />, // Componente que muestra la lista de invitados
        isList: true,
        subpages: [],
        hidden: false,
      },
      {
        icon: <PlusCircleIcon {...icon} />,
        name: "Configuración", // Solo ruta para "Configuración"
        path: "/settings",
        element: <AdminSettings />, // Componente que muestra la configuración del administrador
        isList: false,
        subpages: [],
        hidden: false,
      },
      {
        icon: <BellIcon {...icon} />,
        name: "Notificaciones",
        path: "/notificaciones",
        element: <Notifications />,
        isList: false,
        subpages: [],
        hidden: true,
      },
      {
        icon: <CalendarIcon {...icon} />,
        name: "Calendario",
        path: "/calendario",
        element: <Calendario />,
        isList: false,
        subpages: [],
        hidden: false,
      },
    ],
  },
  {
    userType: "Client", 
    layout: "client",
    pages: [
      {
        icon: <User2 {...icon} />,
        name: "Cuenta", 
        path: "/",
        element: <Account />, 
        isList: true,
        subpages: [],
        hidden: false,
      },
      {
        icon: <EnvelopeIcon {...icon} />,
        name: "Podcast", 
        path: "/podcast/*",
        element: <Podcast />, 
        isList: true,
        subpages: [],
        hidden: true,
      },
      {
        icon: <Calendar {...icon} />,
        name: "Calendario", 
        path: "/calendario/*",
        element: <Podcast />, 
        isList: true,
        subpages: [],
        hidden: false,
      },
     
    ],
  },
];

export default routes;
